import Head from 'next/head';
import { NavBar } from 'components/shared/NavBar';
import Link from 'next/link';

const Page = () => {
	return (
		<>
			<Head>
				<title>Datenschutz | Siccro Active Service</title>
				<meta
					name="description"
					content="Gereinigte Fenster sind eine gute Basis für ein angenehmes Wohnumfeld. Experten von SICCRO empfehlen, zusätzlich einige Pflegemaßnahmen durchzuführen, weil diese sich positiv auf die Lebensdauer auswirken und Ihnen dadurch Kosten sparen."
				/>
			</Head>
			<NavBar />
			<div className="mt-28 container text-4xl text-center md:pt-12 font-black  md:text-5xl mx-auto">
				<h2>Datenschutzerklärung</h2>
			</div>
			<div className=" max-w-[900px] text-xl pt-10 px-30 text-left flex flex-col mx-auto">
				<h3 className="text-2xl py-5 font-black">Allgemeines</h3>
				<p>
					Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten
					daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen
					Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im
					Rahmen unserer Website. Verantwortlicher ist SYMAK AUSTRIA GmbH <br />
					E‑Mail: office@symak.at
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Grundsatz der anonymen Datenverwendung</h3>
				<p>
					Die Nutzung unserer Seite ist grundsätzlich ohne eine Angabe von personenbezogenen Daten möglich.
					Beim Aufruf unserer Webseite werden einige Informationen übertragen, wie z.B. IP-Adresse, Typ und
					Version des verwendeten Webbrowsers, das verwendete Betriebssystem, die Webseite, von der du
					gekommen bist und die Uhrzeit der Abfrage. Diese Daten können von uns nicht dazu verwendet werden,
					den einzelnen Nutzer zu identifizieren. Die Informationen werden von uns lediglich statistisch
					ausgewertet und ausschließlich dazu verwendet, die Attraktivität, Inhalte und Funktionalitäten
					unserer Webseiten zu verbessern. Wir weisen jedoch darauf hin, dass bei einer statischen IP- Adresse
					über eine RIPE- Abfrage im Einzelfall ein Personenbezug möglich sein kann, was wir jedoch nicht tun.
					Dennoch ist diese Website sowohl statisch als auch dynamisch vergebenen IP- Adressen zugänglich.{' '}
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Personenbezogene Daten</h3>
				<p>
					Die gesammelten personenbezogenen Daten benötigen wir für zur Vertragserfüllung, Verrechnung,
					Geltendmachung der Vertragsansprüche, für Zwecke des Kundenservice und für Werbezwecke. Die Daten
					werden hierfür erhoben, gespeichert, verarbeitet und genutzt.Zu diesen Daten zählen Daten die auf
					eine Identifikation der Person schließen lassen wie beispielsweise Name, Anschrift, Telefonnummer
					sowie E‑Mail-Adresse (Art. 4 Z 1 DSGVO). <br />
					<br />
					<br />
					Die Rechtliche Grundlage der Verarbeitung Ihrer Daten liegt in der Einwilligung im Zuge des
					Kontaktformulars oder bei schriftlichem oder mündlichem Vertragsabschluss. Diese Einwilligung können
					Sie jederzeit für die Zukunft widerrufen.
					<br />
					<br />
					Wir verarbeiten Ihre personenbezogenen Daten, soweit erforderlich, für die Dauer der gesamten
					Geschäftsbeziehung (von der Anbahnung, Abwicklung bis zur Beendigung eines Vertrags) sowie darüber
					hinaus gemäß den gesetzlichen Aufbewahrungs- und Dokumentationspflichten, die sich u.a. aus dem
					Unternehmensgesetzbuch (UGB) und der Bundesabgabenordnung (BAO) ergeben sowie bis zur Beendigung
					eines allfälligen Rechtsstreits, fortlaufender Gewährleistungs- und Garantiefristen usw.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Newsletter</h3>
				<p>
					Wir verwenden einen Newsletter für Bestandskunden, um Neuigkeiten und Angebote zu teilen. Mit Angabe
					ihrer E‑Mail-Adresse bei Kontaktaufnahme bzw. Vertragsabschluss willigen sie dem Erhalt des
					Newsletters ein. Selbstverständlich können Sie sich jederzeit von diesem Newsletter abmelden. Dies
					funktioniert durch eine E‑Mail mit kurz gefasster Bestätigung des Widerrufs. <br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Kontakt</h3>
				<p>
					Sie haben die Möglichkeit uns per E‑Mail, per Kontaktformular oder per Telefon zu kontaktieren. Die
					uns auf diese Weise übermittelten persönlichen Daten werden wir selbstverständlich ausschließlich
					für den Zweck verwenden, zu dem Sie uns diese bei der Kontaktierung zur Verfügung stellen. Ohne
					diese Daten können wir Ihre Anfragen nicht bearbeiten. Persönliche Daten werden ohne Ihre
					Einverständniserklärung nicht erhoben oder weitergegeben. <br />
					<br />
					Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des
					Art 6 Abs 1 lit a (Einwilligung) DSGVO.
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Cookies</h3>
				<p>
					Diese Webseite verwendet Cookies. Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren,
					Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren.
					Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale
					Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit
					weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der
					Dienste gesammelt haben. <br />
					<br />
					Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung
					effizienter zu gestalten.
					<br />
					<br />
					Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser Seite
					unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir Ihre Erlaubnis.
					<br />
					<br />
					Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien
					platziert, die auf unseren Seiten erscheinen.
					<br />
					<br />
					Sie können Ihre Einwilligung jederzeit von der Cookie-Erklärung auf unserer Website ändern oder
					widerrufen.
					<br />
					<br />
					Erfahren Sie in unserer Datenschutzrichtlinie mehr darüber, wer wir sind, wie Sie uns kontaktieren
					können und wie wir personenbezogene Daten verarbeiten.
					<br />
					<br />
					Bitte geben Sie Ihre Einwilligungs-ID und das Datum an, wenn Sie uns bezüglich Ihrer Einwilligung
					kontaktieren.
					<br />
					<br />
					Ihre Einwilligung trifft auf die folgenden Domains zu: siccro-fensterservice.at
					<br />
					<br />
					Ihr aktueller Zustand: Alle zulassen. <br />
					<br />
					Ihre Einwilligungs-ID: 4LfukMyTHcZnJctaJNgXwz7mIh5BQKclMftDFnE9FPoKWdH1EkIQeQ==Einwilligungsdatum:
					Mittwoch, 13. Oktober 2021, 10:15:25 MESZ
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Einwilligung und Recht auf Widerruf</h3>
				<p>
					Ist für die Verarbeitung Ihrer Daten Ihre Zustimmung notwendig, verarbeiten wir diese erst nach
					Ihrer ausdrücklichen Zustimmung. Grundsätzlich verarbeiten wir keine Daten minderjähriger Personen
					und sind dazu auch nicht befugt. Mit der Abgabe Ihrer Zustimmung bestätigen Sie, dass Sie das 14.
					Lebensjahr vollendet haben oder die Zustimmung Ihres gesetzlichen Vertreters vorliegt. Ihre
					Zustimmung können Sie jederzeit unter folgender E‑Mail-Adresse widerrufen: office@symak.atIn einem
					solchen Fall werden die bisher über Sie gespeicherten Daten anonymisiert und in weiterer Folge
					lediglich für statistische Zwecke ohne Personenbezug weiterverwendet, sofern keine gesetzlichen
					Aufbewahrungspflichten entgegenstehen. Mittels des Widerrufs der Zustimmung wird die Rechtmäßigkeit,
					der aufgrund der Zustimmung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Keine Datenübermittlung an Dritte</h3>
				<p>
					Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt, es sei denn, wir sind
					gesetzlich dazu verpflichtet, die Datenweitergabe ist zur Durchführung des Vertragsverhältnisses
					erforderlich oder Sie haben zuvor ausdrücklich in die Weitergabe Ihrer Daten eingewilligt. Externe
					Dienstleister und Partnerunternehmen wie z.B. Online-Payment-Anbieter oder das mit der Lieferung
					beauftragte Versandunternehmen erhalten Ihre Daten nur, soweit dies zur Abwicklung Ihrer Bestellung
					erforderlich ist. In diesen Fällen beschränkt sich der Umfang der übermittelten Daten jedoch auf das
					erforderliche Minimum. Soweit unsere Dienstleister mit Ihren personenbezogenen Daten in Berührung
					kommen, stellen wir sicher, dass diese die Vorschriften der Datenschutzgesetze in gleicher Weise
					einhalten.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Datensicherheit</h3>
				<p>
					Wir (SYMAK SWISS AG) setzen technische und organisatorische Sicherheitsmaßnahmen ein, um die
					gespeicherten personenbezogenen Daten gegen zufällige oder vorsätzliche Manipulation, Verlust oder
					Zerstörung und gegen den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen
					werden entsprechend des technischen Fortschritts fortlaufend verbessert.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Ihre Rechte</h3>
				<p>
					Sie haben jederzeit das Recht auf Auskunft über die betreffenden personenbezogenen Daten. Soweit
					keine gesetzliche Aufbewahrungspflicht besteht, haben Sie das Recht auf Löschung dieser Daten sowie
					Widerspruch gegen die Verarbeitung. Ferner haben Sie das Recht auf Berichtigung der Daten sowie auf
					Einschränkung der Verarbeitung, auf Datenübertragbarkeit sowie auf Beschwerde bei der
					österreichischen Datenschutzbehörde (Wickenburggasse 8–10, 1080 Wien, E‑Mail: dsb@dsb.gv.at).
					<br />
					<br />
					Wenden Sie sich bezüglich Ihrer Rechte bitte an uns:
					<br />
					<br />
					SYMAK AUSTRIA GmbH
					<br />
					<br />
					5204 Straßwalchen, Salzburgerstrasse 26
					<br />
					<br />
					E‑Mail: office@symak.at
					<br />
					<br />
					<br />
					<br />
				</p>
			</div>
		</>
	);
};

export default Page;
